export const tax = 1.19;
